import { Box } from "@mui/material";
import styles from "./assignGroup.module.scss";
import i18next from "i18next";
import FormikControl from "../../../../components/formComponents/FormikControl";
import {
  getDropDownValue,
  generalValidationMessage,
} from "../../../../config/appConfig";
import { Form, Formik } from "formik";
import _ from "lodash";
import { useState, useEffect, useCallback } from "react";
import Button from "../../../../components/buttons/Buttons";
import * as Yup from "yup";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import loaderAnimation from "../../../../assets/lotties/loader.json";
import Lottie from "lottie-react";
import {
  getAssignGroupDropDownList,
  postaddAssigntoGroup,
  getGroupCheckName,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const AssignGroup = (props) => {
  let defaultInitialValue = {
    dealerGroup: {},
    Group_name: "",
    email: "",
    City_Headquarters: "",
    isDetailsShow: false,
  };

  const initalValue = defaultInitialValue;
  const [dropDownEnabled, setDropDownEnabled] = useState(false);
  const { handleSubmit, selectionModel } = props;
  const [isDetailsShow, setISDetailsShow] = useState(false);
  const [extractDeatilsLoadingFlag, setExtractDeatilsLoadingFlag] =
    useState(false);
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;

  const setDropdownValue = (
    value,
    dropdownOptions,
    name,
    setFieldValue,
    setFieldTouched
  ) => {
    let selectedOption = getDropDownValue(value, dropdownOptions);
    setFieldValue(name, selectedOption);
    setFieldTouched(name, false);
    setSelectedAssignGroupName(selectedOption?.key);
    setDelearIDGroup(selectedOption?.value);
    setSelectedAssignGroupEmail(value?.emailId);
    setSelectedAssignGroupCity(value?.group_City);
  };

  const handleClose = () => {
    setISDetailsShow(false);
    setDropDownEnabled(false);
  };

  const handleDetailsForm = () => {
    setISDetailsShow(true);
    setDropDownEnabled(true);
  };

  const [isExistingDealerFlag, setIsExistingDealerFlag] = useState(false);
  const [assignGroupList, setAssignGroupList] = useState([]);
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [selectedAssignGroupName, setSelectedAssignGroupName] = useState(null);
  const [selectedAssignGroupEmail, setSelectedAssignGroupEmail] =
    useState(null);
  const [selectedAssignGroupCity, setSelectedAssignGroupCity] = useState(null);
  const [delearIDGroup, setDelearIDGroup] = useState();
  const [groupNameCheck, setGroupNameCheck] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const postApicallAssignGrp = async () => {
    try {
      const response = await postaddAssigntoGroup({
        dealergroup_Id: delearIDGroup,
        group_Name: selectedAssignGroupName,
        group_email_id: selectedAssignGroupEmail,
        group_City: selectedAssignGroupCity,
        isAssign: !_.isEmpty(selectedAssignGroupName),
        dealerIds: selectionModel,
      });

      if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
        _.set(response, "status", 200);
        setApiErrorModalState({ error: response });
        return {
          success: false,
          message: response.errorMessage || "Error occurred.",
        };
      } else if (_.get(response, "success", false) === false) {
        _.set(response, "status", 200);
        return {
          success: false,
          message: response.message || "Group creation failed.",
        };
      } else if (_.get(response, "success", false) === true) {
        _.set(response, "status", 200);
        return {
          success: true,
          message: response.message || "Group assigned successfully.",
        };
      }
      // Default fallback
      return { success: false, message: "Unexpected error." };
    } catch (err) {
      setApiErrorModalState({ error: err });
      return { success: false, message: "Network or server error." };
    }
  };

  const getGroupcheckNameDetails = (value) => {
    const trimmedValue = value.trim();
    getGroupCheckName({ groupName: trimmedValue })
      .then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "status", 200);
          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true)) {
          _.set(response, "status", 200);
          setIsExistingDealerFlag(true);
        } else {
          setGroupNameCheck(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
        setISDetailsShow(true);
      });
  };

  useEffect(() => {
    getAssignGroupDropDownList()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setApiErrorModalState({ error: response });
        } else {
          let updatedResponse = response.map((group) => {
            return {
              ...group,
              ...{
                value: group.dealergroup_Id,
                key: group.group_Name,
                emailId: group.group_email_id,
                groupCity: group.group_City,
              },
            };
          });
          setAssignGroupList(updatedResponse);

          let fetchgroupname = updatedResponse.map((grpname) => {
            return {
              ...{
                key: grpname.group_Name,
              },
            };
          });
          setGroupNameCheck(fetchgroupname);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validationSchema = Yup.object({
    dealerGroup: Yup.object()
      .test("pp", translatedGeneralValidationMessage, (value) => {
        if (isDetailsShow === true) {
          return true;
        }
        return !_.isEmpty(value);
      })
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    Group_name: Yup.string()
      .test("len", translatedGeneralValidationMessage, (val) => {
        if (isDetailsShow === true) {
          if (_.isEmpty(val)) {
            setIsExistingDealerFlag(false);
          } else {
            return true;
          }
        }
        if (isDetailsShow === false) {
          return true;
        }
      })
      .typeError(translatedGeneralValidationMessage),
  });

  const grpnameValidate = (value) => {
    const trimmedValue = value.trim().toLowerCase();
    let isDuplicate = false;
    groupNameCheck?.forEach((keyname) => {
      if (trimmedValue === keyname.key.trim().toLowerCase()) {
        isDuplicate = true;
      }
    });
    if (isDuplicate) {
      getGroupcheckNameDetails(trimmedValue);
    }
    setIsExistingDealerFlag(isDuplicate);
  };

  const debouncedFetch = useCallback(
    _.debounce((val) => {
      grpnameValidate(val);
      setExtractDeatilsLoadingFlag(true);
      setTimeout(() => {
        setExtractDeatilsLoadingFlag(false);
      }, 1000);
    }, 1000),
    [groupNameCheck]
  );

  // const fetchExactData = (value) => {
  //   if (value.length >= 1) {
  //     grpnameValidate(value);
  //     setExtractDeatilsLoadingFlag(true);
  //     setTimeout(() => {
  //       setExtractDeatilsLoadingFlag(false);
  //     }, 2000);
  //   }
  // };

  const loader = () => (
    <Lottie
      animationData={loaderAnimation}
      loop={true}
      height={"21px"}
      width={"21px"}
    />
  );

  return (
    <Box className={styles.dealerExportFormWrapper} data-testid="AssignGroup">
      <Formik
        initialValues={initalValue}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={async (values) => {
          setIsSubmitting(true);

          // Double-check group name if adding new group
          if (isDetailsShow && values.Group_name?.trim()) {
            const trimmedName = values.Group_name.trim().toLowerCase();

            const duplicateExists = groupNameCheck?.some(
              (group) => group.key.trim().toLowerCase() === trimmedName
            );

            if (duplicateExists) {
              setIsExistingDealerFlag(true);
              setIsSubmitting(false);
              return;
            }

            try {
              setExtractDeatilsLoadingFlag(true);
              const response = await getGroupCheckName({
                groupName: trimmedName,
              });
              setExtractDeatilsLoadingFlag(false);

              const backendDuplicate =
                response?.success || response?.errorMessage || false;

              if (backendDuplicate) {
                setIsExistingDealerFlag(true);
                setIsSubmitting(false);
                return;
              }
            } catch (error) {
              setExtractDeatilsLoadingFlag(false);
              setApiErrorModalState({ error });
              setIsSubmitting(false);
              return;
            }
          }

          // Proceed to actual API call
          const result = await postApicallAssignGrp();

          setIsSubmitting(false);
          handleSubmit(values);
        }}
      >
        {({
          errors,
          touched,
          handleSubmit,
          values,
          setFieldValue,
          setFieldTouched,
        }) => {
          return (
            <Form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <Box className={`formWrapper ${styles.assignPageWrapper}`}>
                <Box className={styles.assignDealersGroupText}>
                  <span>
                    {i18next.t("You have")}{" "}
                    <span className={styles.count}>
                      {props.groupCount?.length < 10
                        ? `0${props.groupCount}`
                        : `${props.groupCount}`}
                    </span>{" "}
                    {i18next.t(" selected dealers")}
                  </span>
                </Box>
                <Box className="textboxDoubleWraper">
                  <FormikControl
                    variant="filled"
                    control="autocomplete"
                    dropDownEnabled={dropDownEnabled}
                    label="Groups"
                    options={assignGroupList}
                    hiddenLabel
                    size="small"
                    isSelect={false}
                    disabled={true}
                    id="dealerGroup"
                    name="dealerGroup"
                    noOptionsText={
                      <Box>
                        <Box>{i18next.t("No results found")}</Box>
                      </Box>
                    }
                    placeholder={i18next.t("Select dealer group")}
                    freeSolo={false}
                    hasSubText={true}
                    subTextField={{
                      title: "group_Name",
                      subText: ["group_email_id"],
                    }}
                    onChange={(e, value) => {
                      setDropdownValue(
                        value,
                        assignGroupList,
                        "dealerGroup",
                        setFieldValue,
                        setFieldTouched
                      );
                    }}
                    value={values.dealerGroup}
                    hasError={!!(touched.dealerGroup && errors.dealerGroup)}
                    error={!!(touched.dealerGroup && errors.dealerGroup)}
                    errorMessage={errors?.dealerGroup}
                    className="input-grp__box select"
                  />
                </Box>

                <Box className={styles.assignGroupspanWrapper} id="spanButton">
                  <Box
                    className={
                      isDetailsShow
                        ? `${styles.addGroupLink} ${styles.btngray}`
                        : `${styles.addGroupLink} ${styles.btnblue}`
                    }
                    onClick={() => {
                      setFieldValue("dealerGroup", {});
                      setFieldTouched("dealerGroup", false);
                      handleDetailsForm();
                    }}
                    onKeyDown={() => {}}
                  >
                    {i18next.t("Add new group")}
                  </Box>
                </Box>

                {isDetailsShow ? (
                  <Box className={styles.selectAssignNewWraper}>
                    <div className={styles.DetailsContainer}>
                      <div className={styles.headerContainer}>
                        <h2 className={styles.headerTitle} id="">
                          <span className={styles.modalTitle}>
                            {" "}
                            {i18next.t("New group")}{" "}
                          </span>
                          <IconButton
                            className={styles.CloseIcon}
                            aria-label="close"
                            onClick={() => {
                              if (isSubmitting) return;
                              setFieldValue("Group_name", "");
                              handleClose();
                            }}
                            sx={{
                              position: "relative",
                              right: 8,
                              top: 0,
                              padding: 0,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </h2>
                      </div>
                      <div className={styles.headerContainer}>
                        <Box className={styles.inputBox}>
                          <Box className="textboxDoubleWraper">
                            <FormikControl
                              control="textfield"
                              type="text"
                              hiddenLabel
                              size="small"
                              variant="filled"
                              className="input-grp__box"
                              label={i18next.t("Group name")}
                              id="Group_name"
                              name="Group_name"
                              placeholder={i18next.t("Enter new group name")}
                              value={values.Group_name}
                              onChange={(e) => {
                                const value = _.get(e, "target.value", "");
                                setFieldTouched("Group_name", false);
                                setFieldValue("Group_name", value);
                                setSelectedAssignGroupName(value);
                                if (value.length >= 1) {
                                  debouncedFetch(value);
                                } else {
                                  setIsExistingDealerFlag(false);
                                }
                              }}
                              error={
                                (touched.Group_name && errors.Group_name) ||
                                isExistingDealerFlag
                              }
                              errorMessage={
                                isExistingDealerFlag
                                  ? i18next.t("Group name already exists!")
                                  : errors?.Group_name
                              }
                            />
                            {extractDeatilsLoadingFlag ? (
                              <Box className={styles.loaderWrapper}>
                                {loader()}
                              </Box>
                            ) : null}
                          </Box>

                          <Box className={styles.EmailTextWraper}>
                            <Box className="textboxDoubleWraper">
                              <FormikControl
                                control="textfield"
                                type="text"
                                hiddenLabel
                                size="small"
                                variant="filled"
                                className="input-grp__box"
                                label={i18next.t("Email")}
                                id="email"
                                name="email"
                                placeholder={i18next.t("Enter group email")}
                                value={values.email}
                                onChange={(e) => {
                                  let value = _.get(e, "target.value", "");
                                  setFieldTouched("email", false);
                                  setFieldValue("email", value);
                                  setSelectedAssignGroupEmail(value);
                                }}
                                error={touched.email && errors.email}
                                errorMessage={errors?.email}
                              />
                            </Box>
                          </Box>

                          <Box className={styles.CityTextWraper}>
                            <Box className="textboxDoubleWraper">
                              <FormikControl
                                control="textfield"
                                type="text"
                                hiddenLabel
                                size="small"
                                variant="filled"
                                className="input-grp__box"
                                label={i18next.t("City(headquarters)")}
                                id="City_Headquarters"
                                name="City_Headquarters"
                                placeholder={i18next.t("Enter group city ")}
                                value={values.City_Headquarters}
                                onChange={(e) => {
                                  let value = _.get(e, "target.value", "");
                                  setFieldTouched("City_Headquarters", false);
                                  setFieldValue("City_Headquarters", value);
                                  setSelectedAssignGroupCity(value);
                                }}
                                error={
                                  touched.City_Headquarters &&
                                  errors.City_Headquarters
                                }
                                errorMessage={errors?.City_Headquarters}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </div>
                    </div>
                  </Box>
                ) : null}

                <Box
                  className={
                    isDetailsShow
                      ? `${styles.buttonSectionWrapper} ${styles.buttonSectionWraperModel}`
                      : `${styles.buttonSectionWrapper} ${styles.buttonSectionWraperWModel}`
                  }
                >
                  <Box className={styles.buttonWrapper}>
                    <Button
                      title="Assign to group"
                      iconStyle={""}
                      buttonType="muibtn-primary"
                      withIcon={false}
                      attriType={"submit"}
                      handleClick={() => handleSubmit(values.dealerGroup)}
                      isDisabled={
                        isSubmitting ||
                        (isDetailsShow &&
                          (isExistingDealerFlag || extractDeatilsLoadingFlag))
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default AssignGroup;

AssignGroup.propTypes = {
  handleSubmit: PropTypes.any,
  selectionModel: PropTypes.any,
  groupCount: PropTypes.any,
};
